<div class="scrollable-container bg-muted_0 h-100">
  <div class="header w-100">
    <app-header></app-header>
  </div>
  <div class="custom-height bg-muted_0 py-3">
    <div class="container-xxl container-fluid">
      <div class="row">
        @if(showSidebar | async){
        <div class="col-lg-3 col-12">
          <app-vertical-menu cy-dashboard-menu class="menu-styles">
          </app-vertical-menu>
        </div>
        }
        <div class="col-lg-9 col-12">
          <div class="main-content p-4 bg-white" [ngClass]="layoutClass">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>